import { render } from "./PersonalProjectsSection.vue?vue&type=template&id=39146b6b&scoped=true"
import script from "./PersonalProjectsSection.vue?vue&type=script&lang=js"
export * from "./PersonalProjectsSection.vue?vue&type=script&lang=js"

import "./PersonalProjectsSection.vue?vue&type=style&index=0&id=39146b6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39146b6b"]])

export default __exports__